import { APIVersion } from "app/models/api_version";
import { fGetFunction } from "./firebase";

const baseApiUrl = "version";

export function getAPIVersion(): Promise<APIVersion> {
  return fGetFunction(`${baseApiUrl}`);
}
